import React from "react";
import "./style.css";
// import {} from "./StyledComponents/CardForMobile.style";

const CardForMobile = ({ link, icon }) => {
  return (
    <>
      <a href={link} target="_blank" rel="noopener noreferrer">
        <span className="ref">
          <img src={icon} alt="My mail" />
        </span>
      </a>
    </>
  );
};

export default CardForMobile;
